import { Component, Input, Optional, Self } from '@angular/core';
import { ControlValueAccessor, NgControl } from '@angular/forms';

export type colSize = 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12;
export type inputType = 'text' | 'email' | 'tel' | 'password' | 'number' | 'date' | 'datetime-local';
export type selectType = 'one' | 'multi';

// class a extends les elements de formulaire custom
@Component({ template: '' })
export abstract class BaseField<T, U> implements ControlValueAccessor {
  @Input() disabled = false;
  @Input() showIcon = true;

  public _onChange = (_: any) => {};
  public _onTouched = () => {};

  protected abstract setValue(val: T): void;
  protected abstract onChange(event: U): void;

  constructor(@Self() @Optional() protected control: NgControl) {}

  // -----------------------------------
  //   implement Control value accessor
  // -----------------------------------
  writeValue(value: T): void {
    this.setValue(value);
  }
  registerOnChange(fn: (_: any) => void): void {
    this._onChange = fn;
  }
  registerOnTouched(fn: any): void {
    this._onTouched = fn;
  }
  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }
}
